import {Component, ChangeDetectionStrategy, afterNextRender, signal, inject} from '@angular/core';
import {AnalyticsService} from '@services/analytics.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
	selector: 'peps-cookie-modal',
	imports: [
		TranslatePipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './cookie-modal.component.html',
})
export class CookieModalComponent {

	private readonly analyticsService = inject(AnalyticsService);

	/**
	 * Signal (et non champ simple) : la valeur est posée depuis un hook de rendu,
	 * qui ne déclenche pas de cycle de détection de changement par lui-même.
	 */
	readonly showModal = signal(false);

	constructor() {
		// Le consentement vit dans localStorage, indisponible côté serveur :
		// hasConsent y renvoie toujours null, donc un calcul dans ngOnInit rendait
		// la modale dans le HTML SSR de chaque page, avant qu'elle ne soit retirée
		// à l'hydratation (flash visible). afterNextRender ne s'exécute jamais
		// côté serveur : la modale n'est décidée que dans le navigateur.
		afterNextRender(() => {
			this.showModal.set(this.analyticsService.hasConsent === null);
		});
	}

	acceptCookies(): void {
		this.showModal.set(false);
		this.analyticsService.grant();
	}

	rejectCookies(): void {
		this.showModal.set(false);
		this.analyticsService.deny();
	}
}
